const DAY_MS = 24 * 60 * 60 * 1000;

function atLocalMidnight(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function formatLocalIsoDate(date) {
  const source = atLocalMidnight(date);
  const year = source.getFullYear();
  const month = String(source.getMonth() + 1).padStart(2, "0");
  const day = String(source.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function shiftDays(date, days) {
  const source = atLocalMidnight(date);
  source.setDate(source.getDate() + days);
  return source;
}

export const PERIOD_PRESETS = [
  { value: "TODAY", label: "Hoje" },
  { value: "YESTERDAY", label: "Ontem" },
  { value: "LAST_7_DAYS", label: "Últimos 7 dias" },
  { value: "LAST_31_DAYS", label: "Últimos 31 dias" },
  { value: "CUSTOM", label: "Personalizado" },
];

export function resolvePeriodPreset(preset = "LAST_31_DAYS", now = new Date()) {
  const today = atLocalMidnight(now);
  switch (preset) {
    case "TODAY":
      return { dataInicio: formatLocalIsoDate(today), dataFim: formatLocalIsoDate(today) };
    case "YESTERDAY": {
      const yesterday = shiftDays(today, -1);
      return { dataInicio: formatLocalIsoDate(yesterday), dataFim: formatLocalIsoDate(yesterday) };
    }
    case "LAST_7_DAYS":
      return { dataInicio: formatLocalIsoDate(shiftDays(today, -6)), dataFim: formatLocalIsoDate(today) };
    case "LAST_31_DAYS":
    default:
      return { dataInicio: formatLocalIsoDate(shiftDays(today, -30)), dataFim: formatLocalIsoDate(today) };
  }
}

export function countPeriodDays(dataInicio, dataFim) {
  const start = new Date(`${dataInicio}T00:00:00`);
  const end = new Date(`${dataFim}T00:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return 0;
  return Math.floor((end.getTime() - start.getTime()) / DAY_MS) + 1;
}
